import { FLAG_META, STATUS_LABEL, STATUS_STYLE, HEAT_META, PRIORITY_META, TYPE_LABEL } from "@/lib/constants";

export function StatusBadge({ status }) {
  return (
    <span className={`inline-flex items-center text-[11px] font-semibold px-2.5 py-0.5 rounded-full border ${STATUS_STYLE[status] || STATUS_STYLE.idea}`}>
      {STATUS_LABEL[status] || status}
    </span>
  );
}

export function FlagBadges({ flags = [], size = "sm" }) {
  if (!flags.length) return null;
  return (
    <div className="flex flex-wrap gap-1.5">
      {flags.map((f) => {
        const m = FLAG_META[f];
        if (!m) return null;
        return (
          <span
            key={f}
            data-testid={`flag-${f}`}
            className={`inline-flex items-center gap-1 ${size === "sm" ? "text-[10px] px-2 py-0.5" : "text-xs px-2.5 py-1"} font-semibold rounded-full border ${m.className}`}
          >
            <span className="h-1.5 w-1.5 rounded-full" style={{ background: m.dot }} />
            {m.label}
          </span>
        );
      })}
    </div>
  );
}

export function HeatBadge({ heat }) {
  const m = HEAT_META[heat] || HEAT_META.cold;
  return <span className={`inline-flex text-[11px] font-semibold px-2.5 py-0.5 rounded-full border ${m.className}`}>{m.label}</span>;
}

export function PriorityBadge({ priority }) {
  const m = PRIORITY_META[priority] || PRIORITY_META.medium;
  return <span className={`inline-flex text-[11px] font-semibold px-2.5 py-0.5 rounded-full border ${m.className}`}>Priorität: {m.label}</span>;
}

export function TypePill({ type }) {
  return (
    <span className="inline-flex text-[10px] font-bold uppercase tracking-wider px-2 py-0.5 rounded bg-white/15 text-white/90 backdrop-blur">
      {TYPE_LABEL[type] || type}
    </span>
  );
}
